// todo:: Type of Addresses API response

import IGeoPlace from '../geo-place/geo-place.interface';

export interface AddressesResponse {
  // tslint:disable-next-line:no-any
  links: any;
  addresses: IAddressResponse[];
  count: number;
  totalCount: number;
}

export interface IAddressResponse {
  addressCode: string;
  addressId: number;
  cityDesc: string;
  countryCode: string;
  countryDesc: string;
  domicileNum: string;
  geoPlace: IGeoPlace;
  postalCode: string;
  regionId: number;
  regionCode: string;
  regionDesc: string;
  settlementDesc: string;
  streetName: string;
  timeZone: string;
  crossStreetName1?: string;
}
